import React from 'react';
import { career, profile } from '../../content/site';
import { useTime } from '../../hooks/useTime';
import { formatSeoulStamp } from '../../utils/formatTime';
import didiIdle from '../Desktop/mascot/idle.gif';
import didiStill from '../Desktop/mascot/rest.png';
import { ExpandBar } from './ExpandBar';
import { expandOnClick } from './expandable';
import styles from './Apps.module.css';

interface AboutProps {
    expanded: boolean;
    compact: boolean;
    onToggle: () => void;
}

/** 이 사이트의 주인을 설명하는 마스트헤드. 누르면 펼쳐져 경력까지 보여준다 */
export const About: React.FC<AboutProps> = ({ expanded, compact, onToggle }) => {
    const { date } = useTime();

    return (
        <div
            className={`${styles.expandable} ${expanded ? styles.expandableOpen : ''}`}
            onClick={expandOnClick(expanded, onToggle)}
        >
            <div className={styles.scroller}>
                <div className={`${styles.about} ${expanded ? styles.aboutOpen : ''}`}>
                    <div className={styles.aboutLead}>
                        <p className={styles.masthead}>DKDK</p>
                        <p className={styles.meta}>
                            <time dateTime={date.toISOString()}>{formatSeoulStamp(date)}</time>
                            <span>
                                {profile.links.map(({ label, url }) => <a key={url} href={url}>[{label}]</a>)}
                            </span>
                        </p>
                        <h1 className={styles.greeting}>
                            <span className={styles.hello}>{profile.greeting}</span>
                            <span className={styles.who}>
                                <span className={styles.roles}>
                                    <span className={styles.roleOutline}>{profile.roles[0]}</span>
                                    {' '}
                                    <span className={styles.roleNeon}>{profile.roles[1]}</span>
                                </span>
                                {' '}
                                <span className={styles.nameTail}>{profile.nameKo}입니다.</span>
                            </span>
                        </h1>
                        <p className={styles.intro}>
                            {profile.intro.lead}
                            <br />
                            <mark>{profile.intro.highlight}</mark>{profile.intro.rest}
                        </p>
                        {expanded && <p className={styles.taste}>{profile.taste}</p>}
                    </div>
                    {expanded && (
                        <div className={styles.career}>
                            {career.map(({ title, items }) => (
                                <section key={title}>
                                    <h2 className={styles.careerTitle}>{title}</h2>
                                    <dl className={styles.careerRows}>
                                        {items.map(({ date: period, text }) => (
                                            <React.Fragment key={text}>
                                                <dt>{period}</dt>
                                                <dd>{text}</dd>
                                            </React.Fragment>
                                        ))}
                                    </dl>
                                </section>
                            ))}
                        </div>
                    )}
                    {compact && (
                        <div className={styles.aboutDidi}>
                            <img className={styles.didiIdle} src={didiIdle} alt="" />
                            <img className={styles.didiStill} src={didiStill} alt="" />
                        </div>
                    )}
                </div>
            </div>
            {!compact && <ExpandBar expanded={expanded} onToggle={onToggle} label="경력 보기" />}
        </div>
    );
};

export default About;
